<p>home works!</p>

{{token$ | async}}
